(function () {
  function getProductFormContext() {
    const infoContainer = document.querySelector(".product__info-container");
    if (!infoContainer) return null;

    const productFormComponent = infoContainer.querySelector(
      "product-form.wt-product__add-to-cart",
    );
    if (!productFormComponent) return null;

    const form =
      productFormComponent.querySelector('form[action*="/cart/add"]') ||
      productFormComponent.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;

    return { infoContainer, productFormComponent, form };
  }

  function getSellingPlanInput(form) {
    if (!form) return null;

    let input =
      form.querySelector('input[name="selling_plan"][data-nw-selling-plan]') ||
      document.querySelector(
        `input[name="selling_plan"][data-nw-selling-plan][form="${form.id}"]`,
      );

    if (!input) {
      input = form.querySelector('input[name="selling_plan"]');
    }

    if (!input && form.id) {
      input = document.querySelector(
        `input[name="selling_plan"][form="${form.id}"]`,
      );
    }

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      input.dataset.nwSellingPlan = "true";
      form.appendChild(input);
    }

    return input;
  }

  function getVariantById(variantsData, variantId) {
    return variantsData.find((entry) => String(entry.id) === String(variantId));
  }

  function syncSellingPlan(form, variantsData, variantId) {
    const sellingPlanInput = getSellingPlanInput(form);
    if (!sellingPlanInput) return;

    const variant = getVariantById(variantsData, variantId);
    sellingPlanInput.value = variant?.selling_plan_id || "";
  }

  function getBuyButtonBaseLabel(addButton) {
    if (addButton.dataset.nwBuyLabelBase) {
      return addButton.dataset.nwBuyLabelBase;
    }

    const customLabel = addButton.getAttribute("data-custom-add-label");
    const baseLabel =
      customLabel || window.variantStrings?.addToCart || "Add to cart";
    addButton.dataset.nwBuyLabelBase = baseLabel.trim();
    return addButton.dataset.nwBuyLabelBase;
  }

  function clearSellingPlan(form) {
    const sellingPlanInput = getSellingPlanInput(form);
    if (sellingPlanInput) {
      sellingPlanInput.value = "";
    }
  }

  function formatMoney(cents, sampleFormatted) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    const currency = window.Shopify?.currency?.active || "USD";
    const fractionDigits = sampleFormatted?.includes(".") ? 2 : 0;

    return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  function getBuyOnceVariants(variantsData) {
    return variantsData.filter((entry) => entry.is_14_servings);
  }

  const SUBSCRIPTION_REQUIRED_MSG =
    "Please select a subscription plan to continue.";
  const ONE_TIME_14_ONLY_MSG =
    "One-time purchase is only available for 14 servings.";

  function requiresSellingPlan(variant) {
    return Boolean(variant && !variant.is_14_servings);
  }

  function getFormSellingPlanValue(form) {
    const input = getSellingPlanInput(form);
    return input?.value?.trim() || "";
  }

  function resolveOneTimeVariantId(
    variantsData,
    { useFirstVariant, firstVariantId, currentVariantId },
  ) {
    const buyOnceVariants = getBuyOnceVariants(variantsData);
    if (buyOnceVariants.length === 0) return null;

    if (useFirstVariant) {
      const configuredVariant = getVariantById(variantsData, firstVariantId);
      if (configuredVariant?.is_14_servings) {
        return configuredVariant.id;
      }
      return buyOnceVariants[0].id;
    }

    const currentVariant = getVariantById(variantsData, currentVariantId);
    if (currentVariant?.is_14_servings) {
      return currentVariant.id;
    }

    if (currentVariant?.flavor_name) {
      const flavorMatch = buyOnceVariants.find(
        (entry) => entry.flavor_name === currentVariant.flavor_name,
      );
      if (flavorMatch) return flavorMatch.id;
    }

    return buyOnceVariants[0].id;
  }

  function validateNwBuyBoxFormSubmit(form, variantsData, sectionId) {
    const buyBox = document.querySelector(
      `.nw-buy-box[data-section-id="${sectionId}"]`,
    );
    if (!buyBox) return { allowed: true };

    if (buyBox.querySelector("[data-nw-buy-once]")?.checked) {
      return { allowed: false, silent: true };
    }

    const variantId = form.querySelector('[name="id"]')?.value;
    if (variantId) {
      syncSellingPlan(form, variantsData, variantId);
    }

    const variant = getVariantById(variantsData, variantId);
    if (!requiresSellingPlan(variant)) {
      return { allowed: true };
    }

    if (!getFormSellingPlanValue(form)) {
      return { allowed: false, message: SUBSCRIPTION_REQUIRED_MSG };
    }

    return { allowed: true };
  }

  function bindNwBuyBoxFormSubmitGuard(form, variantsData, sectionId) {
    if (form.dataset.nwBuyBoxSubmitGuard === "true") return;
    form.dataset.nwBuyBoxSubmitGuard = "true";

    form.addEventListener(
      "submit",
      (event) => {
        const result = validateNwBuyBoxFormSubmit(form, variantsData, sectionId);
        if (result.allowed) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (!result.silent && result.message) {
          const context = getProductFormContext();
          if (context) {
            showProductFormError(context.productFormComponent, result.message);
          }
        }
      },
      true,
    );
  }

  function updateBuyButtonPrice(sectionId, variantsData, variantId) {
    const buyBox = document.querySelector(
      `.nw-buy-box[data-section-id="${sectionId}"]`,
    );
    if (buyBox?.classList.contains("is-buy-once-mode")) return;

    const addButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!addButton) return;

    const addButtonText = addButton.querySelector("span");
    if (!addButtonText) return;

    const variant = getVariantById(variantsData, variantId);
    const baseLabel = getBuyButtonBaseLabel(addButton);

    if (!variant?.available || !variant.subscription_price_formatted) {
      addButton.disabled = true;
      addButton.setAttribute("aria-disabled", "true");
      return;
    }

    addButtonText.textContent = `${baseLabel} ${variant.subscription_price_formatted}`;
    addButton.disabled = false;
    addButton.removeAttribute("aria-disabled");
  }

  function getBuyOnceTotals(container) {
    let totalCents = 0;
    let totalQty = 0;

    container.querySelectorAll(".nw-buy-box__buy-once-flavor").forEach((row) => {
      const qty = parseInt(
        row.querySelector(".js-counter-quantity")?.value || "0",
        10,
      );
      const price = parseInt(row.dataset.price, 10) || 0;
      totalCents += qty * price;
      totalQty += qty;
    });

    return { totalCents, totalQty };
  }

  function updateBuyOnceButton(container, sectionId, variantsData) {
    const addButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (!addButton) return;

    const addButtonText = addButton.querySelector("span");
    if (!addButtonText) return;

    const baseLabel = getBuyButtonBaseLabel(addButton);
    const buyOnceVariants = getBuyOnceVariants(variantsData);
    const sampleFormatted = buyOnceVariants[0]?.one_time_price_formatted || "";
    const { totalCents, totalQty } = getBuyOnceTotals(container);
    const cardPriceEl = container.querySelector("[data-buy-once-unit-price]");

    if (cardPriceEl) {
      cardPriceEl.textContent =
        totalQty === 0
          ? sampleFormatted
          : formatMoney(totalCents, sampleFormatted);
    }

    if (totalQty === 0) {
      addButtonText.textContent = `${baseLabel} ${sampleFormatted}`;
      addButton.disabled = true;
      addButton.setAttribute("aria-disabled", "true");
      return;
    }

    const formattedTotal = formatMoney(totalCents, sampleFormatted);
    addButtonText.textContent = `${baseLabel} ${formattedTotal}`;
    addButton.disabled = false;
    addButton.removeAttribute("aria-disabled");
  }

  function getBuyOnceCartItems(container, variantsData) {
    const items = [];

    container.querySelectorAll(".nw-buy-box__buy-once-flavor").forEach((row) => {
      const qty = parseInt(
        row.querySelector(".js-counter-quantity")?.value || "0",
        10,
      );
      if (qty <= 0) return;

      const variantId = parseInt(row.dataset.variantId, 10);
      const variant = getVariantById(variantsData, variantId);
      if (!variant?.is_14_servings) return;

      items.push({
        id: variantId,
        quantity: qty,
      });
    });

    return items;
  }

  function resetBuyOnceQuantities(container, sectionId, variantsData) {
    container.querySelectorAll(".nw-buy-box__buy-once-flavor").forEach((row) => {
      const input = row.querySelector(".js-counter-quantity");
      if (input) {
        input.value = "0";
      }
    });

    if (sectionId && variantsData) {
      updateBuyOnceButton(container, sectionId, variantsData);
    }
  }

  async function refreshCartDrawerContents(cart) {
    const sectionsToRender = cart.getSectionsToRender();
    const sectionIds = sectionsToRender.map((section) => section.id).join(",");
    const response = await fetch(
      `${window.Shopify.routes.root}?sections=${sectionIds}`,
    );
    const sections = await response.json();
    const isClosedCart = !document.body.classList.contains("page-overlay-cart-on");
    cart.renderContents({ sections }, isClosedCart);
  }

  async function addBuyOnceItemsToCart(
    productFormComponent,
    items,
    sectionId,
    submitButton,
  ) {
    const cart = document.querySelector("cart-drawer");
    const cartType = cart?.dataset.cartType || "page";
    const loader = productFormComponent.querySelector(".loading-overlay__spinner");

    submitButton.setAttribute("aria-disabled", "true");
    submitButton.classList.add("loading");
    loader?.classList.remove("hidden");

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items }),
      });
      const data = await response.json();

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          errors: data.errors || data.description,
          message: data.message,
        });
        showProductFormError(
          productFormComponent,
          data.description || data.message,
        );
        return;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        cartData: data,
      });

      if (cart.classList.contains("is-empty")) {
        cart.classList.remove("is-empty");
      }

      if (cartType === "drawer") {
        await refreshCartDrawerContents(cart);
        return;
      }

      window.location = window.routes.cart_url;
    } catch (error) {
      console.error("NW Buy Box buy-once add to cart failed:", error);
    } finally {
      submitButton.classList.remove("loading");
      loader?.classList.add("hidden");

      const buyBox = document.querySelector(
        `.nw-buy-box[data-section-id="${sectionId}"]`,
      );
      if (buyBox?.classList.contains("is-buy-once-mode")) {
        updateBuyOnceButton(
          buyBox,
          sectionId,
          getVariantsDataForSection(sectionId),
        );
      } else {
        submitButton.removeAttribute("aria-disabled");
      }
    }
  }

  function updateOneTimeCta(container, variantsData, variantId) {
    const cta = container.querySelector(".nw-buy-box__one-time-cta");
    if (!cta) return;

    const variant = getVariantById(variantsData, variantId);
    if (!variant) return;

    const compareEl = cta.querySelector(".nw-buy-box__one-time-compare");
    const priceEl = cta.querySelector(".nw-buy-box__one-time-price");

    if (compareEl) {
      if (variant.one_time_show_compare) {
        compareEl.textContent = variant.one_time_compare_price_formatted;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (priceEl) {
      priceEl.textContent = variant.one_time_price_formatted;
    }
  }

  function showProductFormError(productFormComponent, message) {
    if (!message || productFormComponent?.dataset.hideErrors === "true") return;

    const errorWrapper = productFormComponent.querySelector(
      ".product-form__error-message-wrapper",
    );
    const errorMessage = productFormComponent.querySelector(
      ".product-form__error-message",
    );

    if (errorWrapper && errorMessage) {
      errorWrapper.hidden = false;
      errorMessage.textContent = message;
    }
  }

  async function addOneTimeToCart(
    productFormComponent,
    form,
    cta,
    variantIdOverride,
    sectionId,
  ) {
    const variantId =
      variantIdOverride || form.querySelector('[name="id"]')?.value;
    if (!variantId || cta.disabled) return;

    const variantsData = sectionId ? getVariantsDataForSection(sectionId) : [];
    const variant = getVariantById(variantsData, variantId);
    if (variantsData.length && !variant?.is_14_servings) {
      showProductFormError(productFormComponent, ONE_TIME_14_ONLY_MSG);
      return;
    }

    const quantity = form.querySelector('[name="quantity"]')?.value || 1;
    const cart = document.querySelector("cart-drawer");
    const cartType = cart?.dataset.cartType || "page";

    cta.disabled = true;
    cta.setAttribute("aria-busy", "true");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", quantity);

    if (cart && typeof cart.getSectionsToRender === "function") {
      formData.append(
        "sections",
        cart.getSectionsToRender().map((section) => section.id),
      );
    } else {
      formData.append("sections", []);
    }

    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    try {
      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: variantId,
          errors: data.errors || data.description,
          message: data.message,
        });
        showProductFormError(productFormComponent, data.description);
        return;
      }

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: variantId,
        cartData: data,
      });

      if (cart.classList.contains("is-empty")) {
        cart.classList.remove("is-empty");
      }

      if (cartType === "drawer") {
        const isClosedCart = !document.body.classList.contains(
          "page-overlay-cart-on",
        );
        cart.renderContents(data, isClosedCart);
        return;
      }

      window.location = window.routes.cart_url;
    } catch (error) {
      console.error("NW Buy Box one-time add to cart failed:", error);
    } finally {
      cta.disabled = false;
      cta.removeAttribute("aria-busy");
    }
  }

  function getVariantsDataForSection(sectionId) {
    const script = document.querySelector(
      `.nw-buy-box[data-section-id="${sectionId}"] [data-nw-buy-box-variants]`,
    );
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || "[]");
    } catch (error) {
      console.error("NW Buy Box: invalid variants JSON", error);
      return [];
    }
  }

  function initNwBuyBox(container) {
    if (container.dataset.nwBuyBoxInitialized === "true") return;
    container.dataset.nwBuyBoxInitialized = "true";

    const variantsScript = container.querySelector("[data-nw-buy-box-variants]");
    if (!variantsScript) return;

    let variantsData = [];
    try {
      variantsData = JSON.parse(variantsScript.textContent || "[]");
    } catch (error) {
      console.error("NW Buy Box: invalid variants JSON", error);
      return;
    }

    const variantOptions = container.querySelector("variant-options");
    const flavorFieldset = container.querySelector(".nw-buy-box__flavor");
    const planCards = container.querySelectorAll(
      ".nw-buy-box__plan:not([data-buy-once-plan])",
    );
    const buyOncePlan = container.querySelector("[data-buy-once-plan]");
    const buyOnceRadio = buyOncePlan?.querySelector("[data-nw-buy-once]");
    const buyOncePanel = buyOncePlan?.querySelector(".nw-buy-box__buy-once-panel");
    const sectionId = container.dataset.sectionId;

    function isBuyOnceMode() {
      return buyOnceRadio?.checked === true;
    }

    function ensureBuyOnceVisible() {
      if (!buyOncePlan) return;
      buyOncePlan.classList.remove("wt-variant-option--hidden");
      buyOnceRadio?.classList.remove("disabled");
    }

    function enterBuyOnceMode() {
      container.classList.add("is-buy-once-mode");
      if (buyOncePanel) {
        buyOncePanel.hidden = false;
      }

      const { form } = getProductFormContext() || {};
      if (form) {
        clearSellingPlan(form);
      }

      updateBuyOnceButton(container, sectionId, variantsData);
    }

    function exitBuyOnceMode() {
      container.classList.remove("is-buy-once-mode");
      if (buyOncePanel) {
        buyOncePanel.hidden = true;
      }
      resetBuyOnceQuantities(container, sectionId, variantsData);
    }

    function restoreSubscriptionAddButton() {
      if (isBuyOnceMode()) return;

      const variantId = getCurrentVariantId();
      if (!variantId) return;

      updateBuyButtonPrice(sectionId, variantsData, variantId);
    }

    function scheduleSubscriptionAddButtonRestore() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          restoreSubscriptionAddButton();
        });
      });
    }

    function handlePlanSelectionChange() {
      ensureBuyOnceVisible();

      if (isBuyOnceMode()) {
        enterBuyOnceMode();
        return;
      }

      exitBuyOnceMode();
      updatePlanCards();

      const { form } = getProductFormContext() || {};
      const variantId = getCurrentVariantId();
      if (form && variantId) {
        syncSellingPlan(form, variantsData, variantId);
      }

      scheduleSubscriptionAddButtonRestore();
    }

    function getSelectedFlavor() {
      return (
        flavorFieldset?.querySelector('input[type="radio"]:checked')?.value ||
        ""
      );
    }

    function getServingsOptionKey(variant) {
      if (!variant) return "";
      if (variant.option2) return variant.option2;
      return variant.option3 || "";
    }

    function getCurrentVariantId() {
      const { form } = getProductFormContext() || {};
      return form?.querySelector('[name="id"]')?.value || null;
    }

    function syncVariantState() {
      if (isBuyOnceMode()) {
        enterBuyOnceMode();
        return;
      }

      const variantId = getCurrentVariantId();
      if (!variantId) return;

      const { form } = getProductFormContext() || {};
      if (form) {
        syncSellingPlan(form, variantsData, variantId);
      }

      updateBuyButtonPrice(sectionId, variantsData, variantId);
    }

    function handleVariantChange() {
      ensureBuyOnceVisible();

      if (isBuyOnceMode()) {
        enterBuyOnceMode();
        return;
      }

      updatePlanCards();
      syncVariantState();
      scheduleSubscriptionAddButtonRestore();
    }

    function updatePlanCard(card, variant) {
      const servingsEl = card.querySelector(".nw-buy-box__plan-servings");
      const compareEl = card.querySelector(".nw-buy-box__plan-compare");
      const priceEl = card.querySelector(".nw-buy-box__plan-price");
      const perDayEl = card.querySelector(".nw-buy-box__plan-per-day");
      const benefitsEl = card.querySelector(".nw-buy-box__plan-benefits");
      const badgeEl = card.querySelector(".nw-buy-box__plan-badge");
      let tagEl = card.querySelector(".nw-buy-box__plan-tag");

      if (!variant) return;

      if (servingsEl) {
        servingsEl.textContent = variant.servings ? `(${variant.servings})` : "";
        servingsEl.hidden = !variant.servings;
      }

      if (compareEl) {
        if (variant.compare_price > variant.subscription_price) {
          compareEl.textContent = variant.compare_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (priceEl) {
        priceEl.textContent = variant.subscription_price_formatted;
      }

      if (perDayEl) {
        perDayEl.textContent = variant.per_day_text || "";
        perDayEl.hidden = !variant.per_day_text;
      }

      if (benefitsEl) {
        benefitsEl.innerHTML = variant.subscription_benefits || "";
        benefitsEl.hidden = !variant.subscription_benefits;
      }

      if (badgeEl) {
        if (variant.discount_percent > 0) {
          badgeEl.textContent = `SAVE ${variant.discount_percent}%`;
          badgeEl.classList.remove("is-hidden");
        } else {
          badgeEl.classList.add("is-hidden");
        }
      }

      if (variant.tag) {
        if (!tagEl) {
          tagEl = document.createElement("span");
          tagEl.className = "nw-buy-box__plan-tag";
          card.querySelector(".nw-buy-box__plan-card")?.prepend(tagEl);
        }
        tagEl.textContent = variant.tag;
        tagEl.hidden = false;
      } else if (tagEl) {
        tagEl.remove();
      }
    }

    function updatePlanCards() {
      const selectedFlavor = getSelectedFlavor();
      if (!selectedFlavor) return;

      planCards.forEach((card) => {
        const servingsValue = card.dataset.servingsValue;
        const variant = variantsData.find(
          (entry) =>
            entry.option1 === selectedFlavor &&
            getServingsOptionKey(entry) === servingsValue,
        );
        updatePlanCard(card, variant);
      });
    }

    flavorFieldset?.addEventListener("change", handleVariantChange);
    variantOptions?.addEventListener("change", handlePlanSelectionChange);
    variantOptions?.addEventListener("variantChangeEnd", () => {
      requestAnimationFrame(() => {
        ensureBuyOnceVisible();
        handlePlanSelectionChange();
      });
    });

    buyOncePanel?.addEventListener("click", (event) => {
      event.stopPropagation();

      if (event.target.closest(".js-counter-increase, .js-counter-decrease")) {
        requestAnimationFrame(() => {
          updateBuyOnceButton(container, sectionId, variantsData);
        });
      }
    });

    buyOncePanel?.addEventListener("change", (event) => {
      if (event.target.matches(".js-counter-quantity")) {
        updateBuyOnceButton(container, sectionId, variantsData);
      }
    });

    const addButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (addButton && !addButton.dataset.nwBuyOnceBound) {
      addButton.dataset.nwBuyOnceBound = "true";
      addButton.addEventListener(
        "click",
        async (event) => {
          if (!isBuyOnceMode()) return;

          event.preventDefault();
          event.stopPropagation();

          const context = getProductFormContext();
          if (!context) return;

          const items = getBuyOnceCartItems(container, variantsData);
          if (items.length === 0) {
            showProductFormError(
              context.productFormComponent,
              "Please select at least one flavor.",
            );
            return;
          }

          await addBuyOnceItemsToCart(
            context.productFormComponent,
            items,
            sectionId,
            addButton,
          );
        },
        true,
      );
    }

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (sectionId && event.data.sectionId !== sectionId) return;
        handlePlanSelectionChange();
        scheduleSubscriptionAddButtonRestore();
      });
    }

    const { form } = getProductFormContext() || {};
    if (form) {
      bindNwBuyBoxFormSubmitGuard(form, variantsData, sectionId);
    }

    updatePlanCards();
    syncVariantState();
    ensureBuyOnceVisible();

    window.addEventListener(
      "load",
      () => {
        handleVariantChange();
      },
      { once: true },
    );
  }

  function initNwBuyBoxOneTime(container) {
    if (container.dataset.nwOneTimeInitialized === "true") return;
    container.dataset.nwOneTimeInitialized = "true";

    const sectionId = container.dataset.sectionId;
    const useFirstVariant = container.dataset.useFirstVariant === "true";
    const firstVariantId = container.dataset.firstVariantId || null;
    const oneTimeCta = container.querySelector(".nw-buy-box__one-time-cta");
    if (!oneTimeCta) return;

    function getCurrentVariantId() {
      const { form } = getProductFormContext() || {};
      return form?.querySelector('[name="id"]')?.value || null;
    }

    function getOneTimeVariantId() {
      const variantsData = getVariantsDataForSection(sectionId);
      return resolveOneTimeVariantId(variantsData, {
        useFirstVariant,
        firstVariantId,
        currentVariantId: getCurrentVariantId(),
      });
    }

    function syncOneTimeState() {
      const variantsData = getVariantsDataForSection(sectionId);
      const variantId = getOneTimeVariantId();
      if (!variantId || !variantsData.length) return;

      updateOneTimeCta(container, variantsData, variantId);

      const variant = getVariantById(variantsData, variantId);
      if (oneTimeCta) {
        oneTimeCta.disabled = !variant?.is_14_servings || !variant?.available;
      }
    }

    function handleVariantChange() {
      if (useFirstVariant) return;
      syncOneTimeState();
    }

    if (!useFirstVariant) {
      const variantOptions = document.querySelector(
        `.nw-buy-box[data-section-id="${sectionId}"] variant-options`,
      );

      variantOptions?.addEventListener("change", handleVariantChange);
      variantOptions?.addEventListener("variantChangeEnd", handleVariantChange);

      if (
        typeof subscribe === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (sectionId && event.data.sectionId !== sectionId) return;
          handleVariantChange();
        });
      }
    }

    oneTimeCta.addEventListener("click", () => {
      const context = getProductFormContext();
      if (!context) return;
      addOneTimeToCart(
        context.productFormComponent,
        context.form,
        oneTimeCta,
        getOneTimeVariantId(),
        sectionId,
      );
    });

    syncOneTimeState();

    if (!useFirstVariant) {
      window.addEventListener(
        "load",
        () => {
          handleVariantChange();
        },
        { once: true },
      );
    }
  }

  function initAll() {
    document.querySelectorAll(".nw-buy-box").forEach(initNwBuyBox);
    document.querySelectorAll(".nw-buy-box-one-time").forEach(initNwBuyBoxOneTime);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
